import React from 'react'

interface ImageViewerProps {
  url: string
  title: string
  zoom: number
}

const ImageViewer: React.FC<ImageViewerProps> = ({ url, title, zoom }) => {
  return (
    <div className="flex items-center justify-center overflow-auto h-full">
      <img
        src={url}
        alt={title}
        className="max-w-full max-h-full transition-transform duration-200"
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: 'center center',
          objectFit: 'contain',
        }}
      />
    </div>
  )
}

export default ImageViewer
